export const hasProductPermission = (productName) => {
    const user_packagelist = JSON.parse(sessionStorage.getItem('user_package_list')) || [];
    return (user_packagelist || []).some((product) => product?.product_name === productName);
};
